import { Component, Input } from '@angular/core';

@Component({
  selector: 'broker-pencil-svg',
  templateUrl: './pencil-svg.component.svg'
})
export class PencilSvgComponent {
  @Input() cssClasses = '';
}
